import React, { useEffect, useState, useRef } from "react";
import { xcService } from "../../../_services/xcService";
import { useTranslation, withTranslation } from "react-i18next";
import { Avatar, Button, List, Select, Typography, Badge, Spin, Popconfirm, Space } from 'antd';

import { isBrowser } from 'react-device-detect';

import {
    LeftOutlined, FormOutlined, LoadingOutlined, SendOutlined
} from "@ant-design/icons";
import * as _ from 'lodash';
import moment from "moment";
import { v1 as uuidv1 } from "uuid";
import variables from "../../../_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";
import MessageTutor from "./messagetutor";
import TextArea from "antd/es/input/TextArea";

import config from "_config/config.js";
import { io } from "socket.io-client";

import { Radio } from 'antd';

const { Option } = Select;


const MessageTutorView = () => {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const [courses, setCourses] = useState([]);
    const [listChats, setListChats] = useState([]);
    const [chatSel, setChatSel] = useState(null);
    const [lastComment, setLastComment] = useState(null);

    const [lastSender, setLastSender] = useState(null);
    const [messages, setMessages] = useState([]);
    const userStorage = JSON.parse(storage.getItem(variables.USER));
    const [students, setStudents] = useState([]);
    const [studentSel, setStudentSel] = useState(null);
    const [courseSel, setCourseSel] = useState(null)
    const [uuid, setUUID] = useState(null);
    const [online, setOnline] = useState([])
    const [toAdmin, setToAdmin] = useState(false);
    const user = JSON.parse(storage.getItem(variables.USER));
    const [newMessage, setNewMessage] = useState("");
    const userType = storage.getItem(variables.USER_TYPE);
    const [writing, setWriting] = useState(false);
    const scrollRef = useRef();
    const [value, setValue] = useState("1");
    const [uuidSender, setuuidSender] = useState(null);
    const [userProfile, setUserProfile] = useState();
    //Socket
    const socket = useRef();

    const onChangeR = (e) => {

        setValue(e.target.value);
        if (e.target.value !== "COURSE") {
            setCourseSel(null)
        }
    };

    useEffect(() => {
        if (userType) {

            xcService.getToken(userType === 'STUDENT' ? '/v1/me' : userType === 'CENTER' ? '/v1/center/me' : '/v1/tutor/me').then(({ data }) => {
                setUserProfile(data.data)
            });
        }
    }, [userType])

    const showDiff = (date) => {

        var duration = moment().diff(moment(date), 'days');
        if (moment(moment(date).format("YYYY-MM-DD")).isSame(moment().format("YYYY-MM-DD"))) {
            return moment(date).format("HH:mm")
        } else {
            if (duration < 5) {
                if (duration === 0) {
                    duration = 1;
                }
                return t("hace") + " " + duration + " " + (duration == 1 ? t("day") : t("days"));
            } else {
                return moment(date).format("DD/MM/YYYY hh:mm")
            }

        }
    }


    const getListChat = () => {

        xcService.getToken('/v1/tutor/comments')
            .then(({ data }) => {

                if (userType === "COUNSELOR") {
                    let mIni = data.data;
                    xcService.getToken('/v1/tutor/commentsadmin')
                        .then(({ data }) => {
                            if (data.data && data.data[0]) {
                                let mData = data.data[0];
                                mData.profile = "ADMIN"
                                mIni.push(mData);
                            }

                            xcService.getToken('/v1/tutor/commentscenter')
                                .then(({ data }) => {
                                if (data.data && data.data[0]) {
                                    let mData = data.data[0];
                                    mData.profile = "CENTER"
                                    mIni.push(mData);
                                }

                                processChats(mIni)

                            }).catch(err => {
                                processChats(mIni)
                            })


                        }).catch(err => {
                            xcService.getToken('/v1/tutor/commentscenter')
                            .then(({ data }) => {
                                if (data.data && data.data[0]) {
                                    mIni.push(data.data[0]);
                                }

                                processChats(mIni)

                            }).catch(err => {
                                processChats(mIni)
                            })

                        })
                } else {
                    processChats(data.data)
                }
            })
    }

    const chatSelected = (item) => {
        setWriting(false)
        setChatSel(item);
        setUUID(item.uuid)

        getMessages(item.student_id, item);
    }

    const processChats = (data) => {

        setListChats(_.orderBy(data, ["createdAt"], ['desc']));

        if (uuid) {
            let mTutorSel = data.filter(item => item.uuid === uuid)
            if (mTutorSel && mTutorSel[0]) {
                chatSelected(mTutorSel[0])
            }
        }

        socket.current = io(config.socketUrl);

        socket.current.on("getMessage", (data) => {
            setLastComment(data.text);
            setLastSender(data)
            getChatSocket(data)
        });
        socket.current.emit("addUser", user.uuid ?? "master");
        socket.current.on("getUsers", (users) => {

            setOnline(users)
        });

    }


    useEffect(() => {
        if (uuidSender) {
            if (!chatSel) {
                let mSel = listChats.filter(it => it.uuid === uuidSender);
                if (mSel && mSel[0]) {
                    setChatSel(mSel[0]);
                    getMessages(mSel[0].id, mSel[0]);
                    setuuidSender(null);
                }
            } else {
                getMessages(chatSel.id, chatSel);
                setuuidSender(null);
            }


        }
    }, [uuidSender])

    const getChatSocket = (data) => {



        if (data.senderId) {
            setuuidSender(data.senderId)
            setLastComment(data.text);
        }

    }

    const init = () => {
        getListChat();

        xcService.getToken('/v1/tutor/comments/user')
            .then(({ data }) => {

                let mSalida = data.data

                //  setStudents(data.data);
                xcService.getToken('/v1/tutor/comments/students')
                    .then(({ data }) => {

                        mSalida = [...mSalida, ...data.data];

                        mSalida = mSalida.filter(it => {
                            return it.name !== ""
                        })

                        setStudents(mSalida);
                    })
            })


        xcService.getToken('/v1/tutor/comments/groups')
            .then(({ data }) => {
                setCourses(data.data)
            })


        socket.current = io(config.socketUrl);

        socket.current.on("getMessage", (data) => {
            getListChat();
            if (chatSel) {
                chatSelected(chatSel)

            }
        });
        socket.current.emit("addUser", userType === "CENTER" ?  user.uuid : "ADMIN");
        socket.current.on("getUsers", (users) => {
            setOnline(users)
        });

    }
    useEffect(() => {
        init();

    },
        [])

    const onChange = (e) => {
        setNewMessage(e.target.value);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        sendChat();
    };


    const onchangeGroup = (value) => {
        setCourseSel(value);

    };

    const onSearchGroup = (value) => {
    };

    const onChangeStudent = (value) => {

        setStudentSel(value);

        let mTemp = students.filter(it => it.id === value);
        if (mTemp && mTemp[0]) {
            setChatSel(mTemp[0]);
            setUUID(mTemp[0].uuid)
        }
    };

    const onSearchStudent = (value) => {
    };


    const emitSocket = (rec, send, text) => {
        socket.current.emit("sendMessage", {
            receiverId: rec,
            senderId: send,
            text: text,
        });

        socket.current.emit("sendMessage", {
            receiverId: "A_" + rec,
            senderId: send,
            text: text,
        });
    }

    const sendChat = () => {


        let isToCenter = value === "CENTER"
        let isToAdmin = value === "ADMIN"

        if (chatSel && (chatSel.sendByMaster || chatSel.toMaster) || isToAdmin) {
            let payload = {

                comment: newMessage
            };

            xcService.postToken('/v1/tutor/commentsadmin', payload)
                .then(({ data }) => {
                    emitSocket("ADMIN", user.uuid, newMessage);

                    setNewMessage("")
                    setWriting(false)
                    getListChat()

                    if (chatSel) {
                        getMessages(chatSel.id, chatSel)
                    }
                })
        } else {
            if ((chatSel && (chatSel.sendByCenter || chatSel.toCenter)) || isToCenter) {

                let payload = {

                    comment: newMessage
                };

                let mUuid = chatSel && chatSel.center ? chatSel.center.uuid : userProfile.center.uuid;
                if (userType === "CENTER") {
                    mUuid = chatSel.tutor.uuid;
                }


                xcService.postToken('/v1/tutor/commentscenter', payload)
                    .then(({ data }) => {

                        emitSocket(mUuid, user.uuid, newMessage);

                        setNewMessage("")
                        setWriting(false)
                        getListChat()
                        if (chatSel) {
                            getMessages(chatSel.id, chatSel)
                        }
                    })
            } else {
                if (courseSel && value === "COURSE") {
                    let payload = {
                        course_id: courseSel,
                        comment: newMessage
                    };


                    xcService.postToken('/v1/tutor/comments/newgroup', payload)
                        .then(({ data }) => {
                            setNewMessage("")
                            setWriting(false)
                            getListChat()

                        })
                } else {
                    let payload = {
                        students: [uuid],
                        comment: newMessage,
                        toStudent: (chatSel.profile !== "TUTOR" && chatSel.profile !== "COUNSELOR") ? true : false,
                        toOrientador: chatSel.profile === "COUNSELOR" ? true : false,
                        toTutor: chatSel.profile === "TUTOR" ? true : false
                    };



                    xcService.postToken('/v1/tutor/comments/new', payload)
                        .then(({ data }) => {

                            emitSocket(chatSel.uuid, user.uuid, newMessage);

                            setNewMessage("")
                            setWriting(false)
                            getListChat()
                            if (chatSel) {
                                getMessages(chatSel.id, chatSel)
                            }
                        })
                }


            }
        }

        //   dispatch(feedActions.saveChat(payload));
    };

    useEffect(() => {


        socket.current = io(config.socketUrl);
        return () => {

            socket.current.emit("removeUser", user.uuid);
        };
    }, []);


    const getMessages = (id, item) => {

        setLoading(true)
        setMessages([])
        if (item.sendByMaster || item.toMaster) {
            xcService.getToken('/v1/tutor/commentsadmin').then(({ data }) => {
                setMessages(data.data);
                setLoading(false);
            }).catch(e => setLoading(false));
        } else {
            if (item.sendByCenter || item.toCenter) {
                xcService.getToken('/v1/tutor/commentscenter').then(({ data }) => {
                    setMessages(data.data);
                    setLoading(false);
                }).catch(e => setLoading(false));

            } else {
                xcService.getToken('/v1/tutor/comments/' + id)
                    .then(({ data }) => {
                        setLoading(false);
                        setMessages(data.data);
                    }).catch(e => setLoading(false));
            }
        }
    }


    useEffect(() => {
        if (chatSel) {
            let scrollToBot = document.getElementById('content-chat');
            if (scrollToBot) {

                scrollToBot.scrollTop = scrollToBot.scrollHeight;
            }
        }
    }, [messages]);

    const getStudents = () => {

        if (value !== "1") {


            if ((value !== "TUTOR") && (value !== "COUNSELOR")) {
                return students.filter(it => (it.profile !== "COUNSELOR" && it.profile !== "TUTOR"))
            } else {
                return students.filter(it => it.profile === value)
            }


        } else {
            return students
        }


    }


    const isOnline = (item) => {

        try {
                let mUUID = item.uuid;
                if (!item.uuid){
                    if (item.sendByMaster || item.toMaster){
                        mUUID = "ADMIN"
                    }else{
                        if (item.sendByCenter || item.toCenter){
                            mUUID = item.center.uuid;
                        }
                    }
                }

            let mEsta = online.filter((user) => user.userId === mUUID);
            return mEsta.length > 0;
        } catch (e) {
            return false;
        }
    }

    const onChangeToAdmin = (e) => {
        setToAdmin(e.target.checked);
    };


    const IconText = ({ icon, item }) => (
        <Popconfirm
            title={t("borrarmensaje")}
            description={t("borrarmensaje")}

            onConfirm={() => deleteMessage(item)}

            onCancel={cancel}
        ><Space>
                {React.createElement(icon)}
            </Space></Popconfirm>
    );


    const deleteMessage = (item) => {

        if (item.student_id && item.profile === "STUDENT") {
            xcService.deleteToken("/v1/tutor/comments/" + item.student_id).then(data => {
                setChatSel(null);
                init();

            })
        } else {
            if (item.profile === "TUTOR") {
                xcService.deleteToken("/v1/tutor/commentstutor/" + item.student_id).then(data => {
                    setChatSel(null);
                    init();

                })
            } else {
                if (item.sendByCenter || item.toCenter) {
                    xcService.deleteToken("/v1/tutor/center/" + item.center_id).then(data => {
                        setChatSel(null);
                        init();

                    })
                }
            }
        }

    }

    const cancel = (e) => {
    };

    const goWrite = () => {
        setWriting(true);
        setChatSel(null)
    }
    const showLastComment = (item) => {
        if (!lastSender){
            return item.comment;
        }else{
            if (item.profile === "ADMIN" && lastSender.senderId === "ADMIN"){
                return lastSender.text;
            }else{
                if (item.profile === "CENTER" && item.center.uuid === lastSender.senderId ){
                    return lastSender.text;
                }else{

                }
            }
        }
        return item.comment;

    }
    return (
        <>
            <div className={"container container--messages boxed boxed--admin-default"}>
                <div className={"content-messages-top"}>
                    <h1>{t("mensajes.title")}</h1>
                    <Button type="primary"
                        onClick={() => goWrite()}
                        size={'large'} shape="round" icon={<FormOutlined />}>{t("mensajes.redactar")}
                    </Button>


                </div>
                <p>{userType === "TUTOR" ? t("mensajes.desctutor") : t("mensajes.descorienta")}</p>


                <>
                    <div className={`content-messages-mid ${(chatSel || writing) && "is-select-chat"}`}>
                        <div className={"content-messages-left"}>
                            <List
                                itemLayout="horizontal"
                                dataSource={listChats.filter(it => it.comment !== null)}
                                renderItem={(item) => (
                                    <List.Item onClick={(e) => {
                                        chatSelected(item)
                                    }}

                                        className={`preview-chat 
                                        ${chatSel && chatSel.center_id && chatSel.center_id === item.center_id ? "preview-chat--select" :
                                                chatSel && chatSel.profile && item.profile === chatSel.profile && (item.id === chatSel.id) ?
                                                    "preview-chat--select" :
                                                    "preview-chat--not-select"
                                            }
                                        `}
                                    >
                                        <div className={"preview-chat-top"}>
                                            {isOnline(item) ? <Badge color="green" /> : <></>}
                                            {item?.avatar ? <Avatar className={"icon"} src={item?.avatar} /> :
                                                <Avatar className={"icon"}>{item?.name}</Avatar>}
                                            <div className={"name"}>
                                                {item.sendByCenter || item.toCenter ?
                                                    <>{item.center.name}</>
                                                    :
                                                    item.sendByMaster || item.toMaster ?
                                                        <>Master Orion</>
                                                        :
                                                        <>
                                                            {item?.name + " " + item?.surname}
                                                        </>}</div>
                                            <div className={"data"}>{showDiff(item.createdAt)}</div>
                                        </div>
                                        {<div className={"preview-chat-bottom"}>

                                            {showLastComment(item)}

                                        </div>}
                                    </List.Item>
                                )}
                            />


                        </div>
                        <div className={"content-messages-right"}>
                            {!isBrowser &&
                                <Button size={'large'} onClick={() => setChatSel(null)} type="primary"
                                    icon={<LeftOutlined />}>
                                    {t("atras")}
                                </Button>

                            }
                            {writing &&
                                <>

                                    <div><Radio.Group onChange={onChangeR} value={value}>
                                        <Radio value={"1"}>{t("todos")}</Radio>
                                        <Radio value={"STUDENT"}>{t("solalumnos")}</Radio>
                                        {userType !== "TUTOR" && <Radio value={"TUTOR"}>{t("solotutores")}</Radio>}
                                        <Radio value={"COUNSELOR"}>{t("soloorientadores")}</Radio>
                                        <Radio value={"COURSE"}>{t("sgroups")}</Radio>
                                        {userType === "COUNSELOR" && <Radio value={"CENTER"}>{t("toMyCenter")}</Radio>}
                                        {userType === "COUNSELOR" && <Radio value={"ADMIN"}>{t("toMyAdmin")}</Radio>}
                                    </Radio.Group></div>


                                    {value !== "CENTER" && value !== "ADMIN" && value !== "COURSE" &&
                                        <Select
                                            size={'large'}
                                            style={{ width: 360 }}
                                            showSearch
                                            placeholder={t("mensajes.para")}
                                            optionFilterProp="children"
                                            onChange={onChangeStudent}
                                            onSearch={onSearchStudent}
                                            filterOption={(input, option) => {

                                                let mSearch = input.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "")

                                                return (option?.label ?? '').toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)

                                            }
                                            }>
                                            {getStudents().map(tutor => {
                                                return <Option key={tutor.id} value={tutor.id}
                                                    label={tutor.name + " " + tutor.surname}>
                                                    {tutor.name + " " + tutor.surname + " (" + (tutor.profile === "COUNSELOR" ? t("isOrientador") : tutor.profile === "TUTOR" ? t("isTutor") : t("isStudent")) + ")"}</Option>
                                            })
                                            }

                                        </Select>
                                    }
                                    {value !== "CENTER" && value !== "ADMIN" && value === "COURSE" &&
                                        <Select
                                            size={'large'}
                                            style={{ width: 360 }}
                                            showSearch
                                            placeholder={t("mensajes.para")}
                                            optionFilterProp="children"
                                            onChange={onchangeGroup}
                                            onSearch={onSearchGroup}
                                        >
                                            {courses.map(tutor => {
                                                return <Option key={tutor.id} value={tutor.id}
                                                    label={tutor.name}>
                                                    {tutor.name}</Option>
                                            })
                                            }

                                        </Select>
                                    }

                                    <div className="content-chat-box" style={{ marginTop: "16px" }}>
                                        <TextArea
                                            className="chat-box-input"
                                            style={{ resize: "none", height: "70px", padding: "12px 56px 4px 12px" }}
                                            onChange={onChange} />
                                        <Button
                                            onClick={() => sendChat()}
                                            shape="circle"
                                            type="primary"
                                            size="large"
                                            icon={<SendOutlined />}
                                        ></Button>
                                    </div>
                                </>
                            }
                            {!writing && chatSel &&
                                <>
                                    <div id={"content-chat"} className={"content-chat-messages"}>
                                        {!loading ?
                                            <div id={"messages"} className={"messages"}>
                                                {messages && messages.map(item => {

                                                    return <div key={uuidv1()} ref={scrollRef}><MessageTutor
                                                        user={user}
                                                        t={t}
                                                        key={uuidv1()}
                                                        item={item} />
                                                    </div>

                                                })}
                                            </div>
                                            :
                                            <Spin indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />} />
                                        }
                                    </div>
                                    <div className="content-chat-box">
                                        <TextArea allowClear
                                            value={newMessage}
                                            className="chat-box-input"
                                            placeholder={`${t("quedecir")}, ${user.name}?`}
                                            onChange={onChange}
                                        />

                                        <Button
                                            onClick={(e) => handleSubmit(e)}
                                            shape="circle"
                                            type="primary"
                                            size="large"
                                            icon={<SendOutlined />}
                                        />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </>

            </div>
        </>)


}


export default withTranslation()(MessageTutorView);
